import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Stag silhouette uses the ★1 tier art as the fallback. The
// active rendering for Court Stag goes through TIERED_GLYPHS (see
// tieredGlyphs.ts) which routes ★2/★3 to the richer tier images.
export const Stag = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/stag-1.png" size={size} alt="stag" />
)
